import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 0,
  rowsPerPage: 5, // Default rows per page
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload; // Update current page
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload; // Update rows per page
    },
    resetPagination: (state) => {
      state.page = 0; // Reset pagination to the first page
      state.rowsPerPage = 5; // Reset rows per page to default
    },
  },
});

export const { setPage, setRowsPerPage, resetPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
